import axios from "axios";
import { Constants } from "../utils/constants";
import { CookieService } from './cookie.service';
import { Utils } from "../utils/utils";

export const campaignSync = (params = {}) => {
  const clientId = Utils.getRouteParam("clientid")?.toLowerCase();
  return axios.post(Constants.CampaignSyncUrl + `/${clientId}/sync_campaigns`,
    params,
    { headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") } })
    .then((response) => response);
};

export const campaignSyncStatus = (params = {}) => {
  const clientId = Utils.getRouteParam("clientid")?.toLowerCase();
  return axios.get(Constants.CampaignSyncUrl + `/${clientId}/sync_status?sync_id=${params?.sync_id}`,
    { headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") } })
    .then((response) => response);
};

export const placementSyncV2 = (syntheticId, payload) => {
  const clientId = Utils.getRouteParam("clientid")?.toLowerCase();
  return axios.post(Constants.PlacementSyncUrlV2 + `/${syntheticId}/placements/sync?client-id=${clientId}&type=placement`,
    payload,
    { headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") } })
    .then((response) => response);
};

export const getPlatformCampaign = () => {
  const clientId = Utils.getRouteParam("clientid")?.toLowerCase();
  return axios.get(Constants.CampaignSyncUrl + `/${clientId}/campaigns/unmapped`,
    { headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") } })
    .then((response) => response);
};

export const mapPlatformCampaign = (payload) => {
  const clientId = Utils.getRouteParam("clientid")?.toLowerCase();
  return axios.post(Constants.CampaignSyncUrl + `/${clientId}/campaigns/map_campaigns`,
    payload,
    { headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") } })
    .then((response) => response);
};
